import { Flex } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useAuth } from "store/hooks/useAuth";
import { hasModuluesAccess } from "utils/modules-access";
import { PrivateModule } from "_config/routes/base/PrivateModule";
import { Logo } from "../../components/Logo";
import { UserDescription } from "../../components/UserDescription";

export const Header = () => {
  const user = useAuth();
  const hasModules = hasModuluesAccess();

  return (
    <Flex
      as="nav"
      px="8"
      position="sticky"
      zIndex="1"
      top="0"
      w="full"
      bgColor="white"
      borderBottom="1px solid rgb(0 0 0 / 7%)"
      minH="60px"
    >
      <Flex maxW="1200px" w="full" margin="0 auto">
        <Flex w="100%" alignItems="center">
          <Logo />
          <Flex display={{ base: "none", sm: "flex" }}>
            {user && (
              <>
                <Flex
                  as={Link}
                  to="/"
                  ml="1"
                  h="full"
                  px="4"
                  align="center"
                  _hover={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
                >
                  Início
                </Flex>
                {hasModules && (
                  <Flex
                    as={Link}
                    to="/servicos-disponiveis"
                    ml="1"
                    h="full"
                    px="4"
                    align="center"
                    _hover={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
                  >
                    Serviços
                  </Flex>
                )}
                <PrivateModule modules={["LICENCIAMENTO_URBANO"]}>
                  <Flex
                    as={Link}
                    to="/licenciamento-urbano/meus-requerimentos"
                    ml="1"
                    h="full"
                    px="4"
                    align="center"
                    _hover={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
                  >
                    Meus requerimentos
                  </Flex>
                </PrivateModule>
              </>
            )}
          </Flex>
        </Flex>
        <Flex w={{ lg: "100%" }} alignItems="center" justifyContent="flex-end">
          {user && <UserDescription />}
        </Flex>
      </Flex>
    </Flex>
  );
};
